import createPredicateIndexFinder from "./_createPredicateIndexFinder.js";
export default createPredicateIndexFinder(-1);
